// getCustomLocations
// getCustomLocationById
// createCustomLocation
// updateCustomLocation
// deleteCustomLocation
// getNearbyCustomLocations

import api from './api'

export const getCustomLocations = async resortId => {
  try {
    const response = await api.get(`/custom-locations/resort/${resortId}`)
    return response.data
  } catch (err) {
    console.error('Error fetching custom locations:', err)
    throw err
  }
}

export const getCustomLocationById = async id => {
  try {
    const response = await api.get(`/custom-locations/${id}`)
    return response.data
  } catch (err) {
    console.error('Error fetching custom location:', err)
    throw err
  }
}

export const createCustomLocation = async locationData => {
  try {
    const response = await api.post('/custom-locations/add', locationData)
    return response.data
  } catch (err) {
    console.error('Error creating custom location:', err)
    throw err
  }
}

export const updateCustomLocation = async (id, locationData) => {
  try {
    const response = await api.put(`/custom-locations/${id}`, locationData)
    return response.data
  } catch (err) {
    console.error('Error updating custom location:', err)
    throw err
  }
}

export const deleteCustomLocation = async id => {
  try {
    const response = await api.delete(`/custom-locations/${id}`)
    return response.data
  } catch (err) {
    console.error('Error deleting custom location:', err)
    throw err
  }
}

export const deactivateCustomLocation = async id => {
  try {
    const response = await api.put(`/custom-locations/${id}/deactivate`)
    return response.data
  } catch (err) {
    console.error('Error deactivating custom location:', err)
    throw err
  }
}

export const getNearbyCustomLocations = async (
  lat,
  long,
  distance,
  resortId,
) => {
  try {
    const response = await api.get('/custom-locations/nearby', {
      params: { lat, long, distance, resort_id: resortId },
    })
    return response.data
  } catch (err) {
    console.error('Error fetching nearby custom locations:', err)
    throw err
  }
}
